import { ClearFilters, SortSelector, StatusFilter } from 'src/app/pages/search/shared/components';

import { AllFiltersMobileButton } from './components/AllFiltersMobileButton';
import { LocationMobileButton } from './components/LocationMobileButton';
import { TopicsMobileButton } from './components/TopicsMobileButton';
import { TotalResultsText } from './components/TotalResultsText';
import { useMobileFilters } from './hooks/useMobileFilters';

export const MobileFilters: React.FC = () => {
	const {
		data: { isLoading },
	} = useMobileFilters();

	if (isLoading) {
		return null;
	}

	return (
		<div className="mt-4 block md:hidden">
			<div className="container flex items-center justify-between">
				<AllFiltersMobileButton />
				<TotalResultsText />
			</div>

			<div className="mb-4 mt-4 flex gap-4 overflow-x-auto whitespace-nowrap px-4">
				<LocationMobileButton />
				<TopicsMobileButton />
				<StatusFilter desktopView={false} />
				<SortSelector desktopView={false} />
				<ClearFilters />
			</div>
		</div>
	);
};
